import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function PulseLogo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn("size-7", className)}>
      <rect width="32" height="32" rx="8" className="fill-primary" />
      <path
        d="M6 17h5l2.5-6 4 11 3-8 1.5 3H26"
        fill="none"
        className="stroke-primary-foreground"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Centered full-viewport layout for splash, setup and error states. */
export function FullPage({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4 py-12">
      <div className={cn("w-full max-w-md", className)}>{children}</div>
    </main>
  );
}

export function Splash({ label = "Loading Pulse…" }: { label?: string }) {
  return (
    <FullPage className="flex flex-col items-center gap-4 text-center">
      <PulseLogo className="size-10 animate-pulse" />
      <p className="text-sm text-muted-foreground" role="status">
        {label}
      </p>
    </FullPage>
  );
}
